/* SteadyWave · behaviors (vanilla, zero deps). Corre UMA vez por página.
   reveal · stagger · count-up · videowall · carrosséis · acordeões · galeria
   · ATC com a gaveta do Horizon · CTAs que rolam até a oferta · marquee · "show more" das reviews */
(function () {
  if (window.__steadywaveInit) return;
  window.__steadywaveInit = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  function boot() {

    /* ---------- reveal + stagger: entram ao chegar na viewport ---------- */
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    var aRevelar = $$('.sw-reveal, .sw-stagger, .swrv__summary');
    aRevelar.forEach(function (el) { rio.observe(el); });
    /* seguro: se o observer não disparar (print de página inteira, browser antigo,
       aba em segundo plano), nada pode ficar invisível. */
    setTimeout(function () { aRevelar.forEach(function (el) { el.classList.add('is-in'); }); }, 2600);

    /* ---------- count-up dos números (só uma vez, ao entrar) ---------- */
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var alvo = parseFloat(el.getAttribute('data-sw-num'));
        if (isNaN(alvo)) return;
        var pre = el.getAttribute('data-sw-pre') || '';
        var suf = el.getAttribute('data-sw-suf') || '';
        var dec = (String(alvo).split('.')[1] || '').length;
        if (RM) { el.textContent = fmt(alvo); return; }   /* a fmt local já põe pre/suf e o milhar */
        var t0 = null, dur = 1500;
        function fmt(v) {
          var s = dec ? v.toFixed(dec) : String(Math.round(v));
          if (!dec && Math.abs(alvo) >= 1000) s = Math.round(v).toLocaleString('en-US');
          return pre + s + suf;
        }
        function tick(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(alvo * eased);
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    $$('[data-sw-num]').forEach(function (el) { cio.observe(el); });

    /* ---------- videowall: os clipes rodam TODOS ao mesmo tempo ----------
       Antes cada clipe só tocava quando 45% dele estava no ecrã, e num carrossel
       horizontal isso fazia os cartões das pontas ficarem parados enquanto os do meio
       andavam. O operador quer a parede toda em movimento. O observador continua, mas
       agora dispara com o BLOCO à vista (não com o cartão), e aí toca tudo de uma vez.
       O `rootMargin` arranca-os um pouco antes de a secção entrar, para já estarem a
       andar quando ela aparece. */
    /* Quem é observado é a SECÇÃO, não cada clipe. Observar os clipes não funciona
       aqui: eles vivem num carrossel com `overflow-x`, e o IntersectionObserver conta
       o recorte dos ancestrais, por isso os cartões fora da janela do carrossel nunca
       intersectavam e ficavam parados. Com a secção à vista, toca tudo de uma vez. */
    var vio = { observe: function () {} };
    $$('.swug').forEach(function (sec) {
      new IntersectionObserver(function (es) {
        var dentro = es[0] && es[0].isIntersecting;
        $$('[data-sw-clip]', sec).forEach(function (v) {
          if (dentro) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0, rootMargin: '400px 0px' }).observe(sec);
    });
    /* `[data-sw-clip]` e nao a classe do cartao: os clipes mudaram de bloco uma vez
       (filmstrip do reviews -> secao `sw-ugc`) e o seletor por classe teria ficado
       para tras sem ninguem dar conta, com os videos parados. */
    $$('[data-sw-clip]').forEach(function (v) { v.muted = true; v.playsInline = true; vio.observe(v); });
    $$('[data-sw-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var clip = btn.closest('.swug__card, .swvw__clip'), v = clip && clip.querySelector('video');
        if (!v) return;
        var on = v.muted;
        $$('[data-sw-clip]').forEach(function (o) { o.muted = true; });
        $$('[data-sw-sound]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        v.muted = !on;
        if (clip) clip.classList.toggle('is-unmuted', !v.muted);
        btn.setAttribute('aria-pressed', String(!v.muted));
      });
    });

    /* ---------- marquee: duplica o conjunto para o loop ficar contínuo ---------- */
    /* A faixa corre em ecra estreito e para no desktop (ver parts/marquee.css), por
       isso o clone que evita a costura do loop so e preciso abaixo de 900px. No
       desktop o `display: contents` do set faria os quatro itens virarem oito. */
    if (window.matchMedia('(max-width: 899px)').matches) {
      $$('[data-sw-marquee]').forEach(function (track) {
        var set = track.firstElementChild; if (!set) return;
        var c = set.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c);
      });
    }

    /* ---------- carrosséis ---------- */
    /* Carrossel INFINITO e centrado (data-sw-loop), portado da Storyelle.
       Três cópias dos slides e o viewport sempre na do meio: ao chegar perto de uma
       ponta salta uma cópia inteira, sem animação, e o olho não vê o salto porque a
       imagem é a mesma. Toque usa o scroll nativo; com rato arrasta-se. */
    function carrosselInfinito(track, root) {
      var orig = $$('.sw-car__slide', track), n = orig.length; if (n < 2) return;
      root.classList.add('sw-car--loop');
      var pre = document.createDocumentFragment(), post = document.createDocumentFragment();
      orig.forEach(function (s) {
        [pre, post].forEach(function (frag) {
          var c = s.cloneNode(true); c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          $$('button, a', c).forEach(function (el) { el.tabIndex = -1; });
          frag.appendChild(c);
        });
      });
      track.insertBefore(pre, track.firstChild); track.appendChild(post);
      var all = $$('.sw-car__slide', track);
      function larguraSet() { return all[n].offsetLeft - all[0].offsetLeft; }
      function centro(el) { return el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2; }
      function maisPerto() {
        var c = track.scrollLeft + track.clientWidth / 2, melhor = 0, d0 = 1e9;
        all.forEach(function (el, i) {
          var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - c);
          if (d < d0) { d0 = d; melhor = i; }
        });
        return melhor;
      }
      function salto(dx) {
        track.style.scrollSnapType = 'none'; track.scrollLeft += dx;
        requestAnimationFrame(function () { track.style.scrollSnapType = ''; });
      }
      function normaliza() {
        var w = larguraSet(), c = track.scrollLeft + track.clientWidth / 2, base = all[0].offsetLeft;
        if (c < base + w) salto(w); else if (c > base + 2 * w) salto(-w);
      }
      function vai(i) { track.scrollTo({ left: centro(all[i]), behavior: RM ? 'auto' : 'smooth' }); }
      requestAnimationFrame(function () { track.scrollLeft = centro(all[n]); });
      var st; track.addEventListener('scroll', function () {
        clearTimeout(st); st = setTimeout(normaliza, 140);
      }, { passive: true });
      var prev = root.querySelector('[data-sw-prev]'), next = root.querySelector('[data-sw-next]');
      if (prev) prev.addEventListener('click', function () { vai(Math.max(0, maisPerto() - 1)); });
      if (next) next.addEventListener('click', function () { vai(Math.min(all.length - 1, maisPerto() + 1)); });
      var down = false, sx = 0, sl = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; sx = e.clientX; sl = track.scrollLeft; track.classList.add('is-drag');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return; track.scrollLeft = sl - (e.clientX - sx);
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false; track.classList.remove('is-drag'); vai(maisPerto());
      });
    }

    $$('[data-sw-car]').forEach(function (track) {
      var root = track.closest('.sw-car'); if (!root) return;
      if (track.hasAttribute('data-sw-loop')) { carrosselInfinito(track, root); return; }
      var dotsWrap = root.querySelector('[data-sw-dots]');
      var prev = root.querySelector('[data-sw-prev]'), next = root.querySelector('[data-sw-next]');
      function slidesVisiveis() { return $$('.sw-car__slide', track).filter(function (el) { return !el.hidden; }); }
      var slides = slidesVisiveis(), dots = [];
      function gap() { return parseFloat(getComputedStyle(track).columnGap) || 16; }
      function step() { var s = slides[0]; return s ? s.getBoundingClientRect().width + gap() : track.clientWidth; }
      function avail() { var cs = getComputedStyle(track); return track.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0); }
      function pages() { var vis = Math.max(1, Math.floor((avail() + gap()) / step())); return Math.max(1, slides.length - vis + 1); }
      function sync() { if (!dots.length) return; var idx = Math.min(dots.length - 1, Math.round(track.scrollLeft / step())); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); }); }
      function build() {
        if (dotsWrap) dotsWrap.innerHTML = '';
        slides = slidesVisiveis();
        dots = []; var n = pages();
        root.classList.toggle('sw-car--static', n <= 1);
        if (dotsWrap) for (var i = 0; i < n; i++) (function (i) {
          var d = document.createElement('button'); d.type = 'button'; d.className = 'sw-car__dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(d); dots.push(d);
        })(i);
        sync();
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      var rto; window.addEventListener('resize', function () { clearTimeout(rto); rto = setTimeout(build, 150); });
      build();
    });

    /* ---------- acordeões: altura animada, sem flash do 1.º frame ---------- */
    $$('details[data-sw-acc]').forEach(function (d) {
      var s = d.querySelector('summary'), panel = s && s.nextElementSibling; if (!panel) return;
      var anim = null, EO = 'cubic-bezier(.22,1,.36,1)', EI = 'cubic-bezier(.45,0,.55,.2)';
      d.style.overflowAnchor = 'none';
      function clear() { panel.style.height = ''; panel.style.opacity = ''; panel.style.overflow = ''; }
      s.addEventListener('click', function (e) {
        if (RM) return;
        e.preventDefault();
        if (anim) { anim.cancel(); anim = null; clear(); }
        if (!d.open) {
          panel.style.height = '0px'; panel.style.opacity = '0'; panel.style.overflow = 'hidden'; d.open = true;
          var h = panel.scrollHeight;
          anim = panel.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 380, easing: EO, fill: 'forwards' });
          anim.onfinish = function () { anim.cancel(); clear(); anim = null; };
        } else {
          var hh = panel.offsetHeight; panel.style.overflow = 'hidden';
          anim = panel.animate([{ height: hh + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: EI, fill: 'forwards' });
          anim.onfinish = function () { d.open = false; anim.cancel(); clear(); anim = null; };
        }
      });
    });

    /* ---------- galeria: thumbs ↔ stage + contador ---------- */
    $$('[data-sw-gal]').forEach(function (gal) {
      var stage = gal.querySelector('[data-sw-stage]'); if (!stage) return;
      var slides = $$('[data-sw-slide]', stage), thumbs = $$('.sw-gal__thumb', gal), count = gal.querySelector('[data-sw-count]');
      var dots = $$('.sw-gal__dots i', gal);   /* pode não existir: a nav foi removida */
      var atual = 0;
      function setActive(i) {
        atual = i;
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
        dots.forEach(function (d, di) { d.classList.toggle('is-on', di === i); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        var t = thumbs[i];
        if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          var strip = t.parentElement;
          strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
      function go(i) {
        var s = slides[i]; if (!s) return;
        stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
        setActive(i);
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var st; stage.addEventListener('scroll', function () {
        clearTimeout(st); st = setTimeout(function () {
          var c = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
          slides.forEach(function (s, i) { var sc = s.offsetLeft - stage.offsetLeft + s.offsetWidth / 2, dd = Math.abs(sc - c); if (dd < bd) { bd = dd; best = i; } });
          setActive(best);
        }, 90);
      }, { passive: true });
    });

    /* ---------- CTAs fora da buybox: rolam até a oferta, nunca compram direto ----------
       Regra do operador: só o botão da buybox adiciona ao carrinho. Tudo o resto leva
       o visitante até as barras do Kaching (ou, se o app ainda não estiver montado,
       até o topo da buybox). */
    function alvoDaOferta() {
      /* Em ordem de prioridade, UM seletor de cada vez. Com a lista toda dentro de um
         `querySelector` o navegador devolve o primeiro elemento do DOM que bate com
         QUALQUER item da lista, e o `[data-sw-offer-anchor]` (um div de altura 0)
         ganhava sempre: nenhum CTA rolava para lado nenhum.

         2026-09-25: o app do Kaching foi desligado pelo operador de propósito. A oferta
         desta PDP é o seletor de packs em código (`[data-sw-packs]`), por isso ele passou
         a ser o PRIMEIRO alvo. Os seletores do app ficam atrás dele, e não à frente, para
         o dia em que o embed volte a ser ligado: se voltar, ele aparece dentro da buybox
         e o seletor em código continua a ser o alvo certo.

         O fallback `#sw-buy` é a buybox inteira, 1745px de altura: serve para não deixar
         o clique morto, mas o `sw-flash` numa caixa desse tamanho não se lê. */
      var sels = ['[data-sw-packs]', 'kaching-bundles-block', 'kaching-bundle',
                  '.kaching-bundles', '.kaching-bundles__block', '[data-sw-offer-anchor]'];
      for (var i = 0; i < sels.length; i++) {
        var el = document.querySelector(sels[i]);
        if (el && el.getBoundingClientRect().height > 8) return el;
      }
      return document.getElementById('sw-buy');
    }
    /* No tema Horizon quem rola NÃO é a janela: `html` e `body` estão em
       `overflow: hidden` e o scroller real é `.page-wrapper`. Por isso
       `window.scrollTo` não movia nada e nenhum CTA chegava às barras.
       Esta função sobe a árvore até achar quem de facto rola. */
    function scrollerDe(el) {
      var n = el.parentElement;
      while (n && n !== document.documentElement) {
        var ov = getComputedStyle(n).overflowY;
        if ((ov === 'auto' || ov === 'scroll') && n.scrollHeight > n.clientHeight + 4) return n;
        n = n.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    }
    /* 2026-09-30 (operador: "nao esta a ir exatamente para os bundles"). Duas correcoes:
       1. o ponto de chegada passa a ser o TITULO dos pacotes ("Summer Sale..."), que vive
          logo acima das barras do Kaching; com o alvo nas barras, o titulo ficava por baixo
          do cabecalho fixo no desktop;
       2. a folga deixa de ser 90px fixos e passa a ser a altura real do cabecalho (60px no
          celular, 68px no desktop) + 16px, medida no momento do clique.
       Depois da rolagem suave confere a posicao e corrige se algo carregou pelo meio. */
    /* 2026-09-30 (operador): o ponto de chegada e o #sw-form, o formulario dos pacotes (comeca no
       titulo "Summer Sale..." e tem as barras do Kaching e o botao). A folga e a soma de tudo o que
       fica FIXO no topo do ecra nesse momento (cabecalho sticky e qualquer barra fixa), medida no
       clique, + 12px. A posicao e corrigida quando a rolagem acaba (scrollend, ou 1,6s sem ele),
       porque imagens e o app podem mudar a altura do que esta acima durante a animacao. */
    function pontoDeChegada(t) { return document.getElementById('sw-form') || t; }
    function folgaTopo() {
      var fundo = 0;
      $$('body *').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        var r = el.getBoundingClientRect();
        if (r.height < 20 || r.height > 220 || r.width < innerWidth * 0.6) return;   /* so barras largas no topo */
        if (r.top <= 2 && r.bottom > fundo) fundo = r.bottom;
      });
      if (!fundo) { var h = document.querySelector('header.shopify-section, .header-section'); fundo = h ? Math.max(0, h.getBoundingClientRect().bottom) : 70; }
      return Math.round(Math.min(Math.max(fundo, 0), 220) + 12);
    }
    function rolarAte(t) {
      var p = pontoDeChegada(t), sc = scrollerDe(p), raiz = document.scrollingElement || document.documentElement;
      var ev = (sc === raiz) ? window : sc;
      function atual() { return (sc === raiz) ? window.pageYOffset : sc.scrollTop; }
      function destino() {
        var f = folgaTopo();
        return (sc === raiz) ? p.getBoundingClientRect().top + window.pageYOffset - f
                             : p.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - f;
      }
      sc.scrollTo({ top: Math.max(0, destino()), behavior: RM ? 'auto' : 'smooth' });
      var feito = false;
      function corrige() {
        if (feito) return; feito = true; ev.removeEventListener('scrollend', corrige);
        var y = destino(); if (Math.abs(y - atual()) > 4) sc.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
        setTimeout(function () { var y2 = destino(); if (Math.abs(y2 - atual()) > 4) sc.scrollTo({ top: Math.max(0, y2), behavior: 'auto' }); }, 500);
      }
      ev.addEventListener('scrollend', corrige);
      setTimeout(corrige, 1600);
    }
    /* ---------- chegada vinda de outro sitio (2026-10-01, operador) ----------
       Quem chega pela URL (#sw-form ou ?pack=N) nao precisa de animacao: salta direto para o
       #sw-form. Mas a pagina ainda esta a carregar (galeria, contagem da promocao, apps), e o que
       esta ACIMA do formulario cresce depois do salto e empurra-o para baixo (medido: 133px no
       motor do Safari). Por isso a `vigia` segura o formulario no sitio durante 8s, e larga-o logo
       que o visitante toca, rola, clica ou usa o teclado. */
    function acertaJa(p) {
      var sc = scrollerDe(p), raiz = document.scrollingElement || document.documentElement, f = folgaTopo();
      var y = (sc === raiz) ? p.getBoundingClientRect().top + window.pageYOffset - f
                            : p.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - f;
      sc.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    }
    function chegarAoForm(alvo) {
      var p = alvo || document.getElementById('sw-form') || alvoDaOferta(); if (!p) return;
      acertaJa(p);
      var fim = Date.now() + 8000, largou = false;
      function larga() { largou = true; }
      ['wheel', 'touchstart', 'mousedown', 'keydown'].forEach(function (ev) { window.addEventListener(ev, larga, { passive: true, once: true }); });
      (function vigia() {
        if (largou || Date.now() > fim) return;
        if (Math.abs(p.getBoundingClientRect().top - folgaTopo()) > 4) acertaJa(p);
        setTimeout(vigia, 200);
      })();
    }
    /* ---------- videos preguicosos (2026-09-30, checklist do Jeff: velocidade) ----------
       `<video data-sw-lazyvid preload="none">` com `<source data-src>`: nada descarrega ao abrir a
       pagina. O src entra quando o video chega perto do ecra (ou, nas reviews, quando a aba dos
       videos abre, que chama window.swLoadVideo). Os que tem autoplay comecam a tocar sozinhos. */
    window.swLoadVideo = function (v) {
      if (!v || v.getAttribute('data-sw-loaded')) return;
      var ss = v.querySelectorAll('source[data-src]'); if (!ss.length) return;
      ss.forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
      v.setAttribute('data-sw-loaded', '1'); v.preload = 'auto'; v.load();
    };
    var lazyVids = document.querySelectorAll('video[data-sw-lazyvid]');
    if (lazyVids.length) {
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var v = e.target; vio.unobserve(v); window.swLoadVideo(v);
            if (v.hasAttribute('autoplay')) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          });
        }, { rootMargin: '400px 0px' });
        lazyVids.forEach(function (v) { vio.observe(v); });
      } else { lazyVids.forEach(function (v) { window.swLoadVideo(v); }); }
    }

    /* ---------- ?pack=N vindo da home (2026-09-30) ----------
       Os cartoes dos pacotes na home levam a PDP com ?pack=1|2|3. O Kaching ignora ?variant= e
       abre sempre no Duo, por isso aqui escolhe-se a barra N quando ela aparece e rola-se ate aos
       pacotes. Espera o app ate 10s; se nao chegar, nao faz nada. */
    (function () {
      var m = /[?&]pack=([1-9])/.exec(location.search); if (!m) return;
      var n = parseInt(m[1], 10) - 1, t0 = Date.now();
      (function tenta() {
        var bars = document.querySelectorAll('kaching-bundles-block .kaching-bundles__bar');
        if (bars.length > n) {
          var bar = bars[n], r = bar.querySelector('input[type=radio]');
          if (r && !r.checked) r.click(); else if (!r) bar.click();
          setTimeout(chegarAoForm, 150);
          return;
        }
        if (Date.now() - t0 < 10000) setTimeout(tenta, 200);
      })();
    })();

    /* ---------- chegada com #sw-form, ou outra ancora #sw-... (2026-10-01, operador + checklist da home) ----------
       Os botoes das outras paginas (home, About, FAQ, Contact, Track, guias, politicas) levam a
       /products/steadywave#sw-form. ⚠️ Desde 2026-10-01 (operador) NENHUM botao de fora usa este destino: abrem a PDP no topo; so os ?pack=N vao aos pacotes. Fica para links antigos. O salto
       nativo do browser acontece logo (com o scroll-margin-top do #sw-form a descontar o cabecalho);
       aqui espera-se o Kaching montar as barras, que muda a altura do que esta acima, e acerta-se com
       o mesmo rolarAte dos botoes da PDP. Nao mexe na barra escolhida (isso e so o ?pack=N). */
    (function () {
      /* Checklist da home: "See the full terms" (#sw-guarantee) caia 3.688px fora no iPhone e
         "Read all 20 reviews" (#sw-reviews) 116px abaixo no desktop. Agora qualquer #sw-... usa a
         mesma chegada (salto + vigia de 8s). */
      if (!/^#sw-[\w-]+$/.test(location.hash) || /[?&]pack=/.test(location.search)) return;
      var destinoHash = document.querySelector(location.hash); if (!destinoHash) return;
      var t0 = Date.now();
      (function tenta() {
        var bars = document.querySelectorAll('kaching-bundles-block .kaching-bundles__bar');
        if (bars.length || Date.now() - t0 > 10000) {
          setTimeout(function () { chegarAoForm(destinoHash); }, 150);
          return;
        }
        setTimeout(tenta, 200);
      })();
    })();

    $$('[data-sw-cta]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        /* ⚠️ O `preventDefault` vinha ANTES desta linha, e isso matava o link em todas
           as paginas que nao a PDP: fora dela `alvoDaOferta()` devolve null, saiamos
           pelo `return` e o clique ja tinha sido cancelado. O <a> tem href para a PDP
           e nao ia a lado nenhum. So cancelamos o percurso normal quando ha mesmo
           para onde rolar. */
        var t = alvoDaOferta(); if (!t) return;
        e.preventDefault();
        rolarAte(t);
        t.classList.add('sw-flash');
        setTimeout(function () { t.classList.remove('sw-flash'); }, 1400);
      });
    });

    /* 2026-10-01: usado pelo sw-nav.js (links do menu e do rodape para uma seccao da pagina em que se esta). */
    window.swIrPara = function (t) {
      if (!t) return;
      if (t.id === 'sw-form') { rolarAte(t); return; }
      var sc = scrollerDe(t), raiz = document.scrollingElement || document.documentElement;
      var top = (sc === raiz) ? t.getBoundingClientRect().top + window.pageYOffset - folgaTopo()
                              : t.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - folgaTopo();
      sc.scrollTo({ top: Math.max(0, top), behavior: RM ? 'auto' : 'smooth' });
    };

    /* ---------- e-book: janela "What's inside" (2026-10-03, operador) ----------
       O <dialog> nasce dentro do formulario dos pacotes (snippet sw-ebook-card) e passa para o <body>,
       para nao herdar o layout do formulario. Fecha no X, no fundo escuro e no Esc (nativo do dialog).
       "Choose my pack" fecha e rola ate aos pacotes, como os outros CTAs da pagina. */
    (function () {
      var dlg = document.getElementById('swebk-dlg');
      if (!dlg) return;
      if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
      var html = document.documentElement;
      function abrir() {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        html.classList.add('swebk-lock');
        var sc = dlg.querySelector('.swebk-dlg__sc'); if (sc) sc.scrollTop = 0;
      }
      function fechar() {
        if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open');
        html.classList.remove('swebk-lock');
      }
      dlg.addEventListener('close', function () { html.classList.remove('swebk-lock'); });
      $$('[data-swebk-open]').forEach(function (b) { b.addEventListener('click', abrir); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-swebk-close]')) { fechar(); return; }   /* e.target === dlg: toque no fundo */
        if (e.target.closest('[data-swebk-pick]')) {
          fechar();
          var f = document.getElementById('sw-form');
          if (f && window.swIrPara) window.swIrPara(f);
        }
      });
    })();

    /* Ligacoes internas da pagina (#sw-...). A ancora nativa do browser nao mexe nada
       aqui, porque quem rola e a `.page-wrapper` e nao a janela, por isso o salto tem
       de passar pelo mesmo `scrollerDe` dos CTAs. */
    $$('a[href^="#sw-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        var sc = scrollerDe(t), raiz = document.scrollingElement || document.documentElement;
        var top = (sc === raiz)
          ? t.getBoundingClientRect().top + window.pageYOffset - folgaTopo()
          : t.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - folgaTopo();
        sc.scrollTo({ top: Math.max(0, top), behavior: RM ? 'auto' : 'smooth' });
      });
    });

    /* ---------- Add to cart → gaveta do Horizon já atualizada ---------- */
    function refreshDrawer() {
      /* 2026-10-02: gaveta propria da SteadyWave (sw-cart.js), quando ligada */
      if (window.SWCart && window.SWCart.active) return window.SWCart.open(true);
      return fetch('/?sections=cart-drawer-section', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var html = d && d['cart-drawer-section']; if (!html) throw new Error('no drawer');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.cart-drawer__inner'), cur = document.querySelector('#cart-drawer .cart-drawer__inner');
          var drawer = document.getElementById('cart-drawer');
          if (!fresh || !cur || !drawer || typeof drawer.open !== 'function') throw new Error('no drawer');
          cur.replaceWith(document.importNode(fresh, true));
          drawer.open();
        });
    }
    function refreshCount() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(c.item_count), timestamp: Date.now() })); } catch (e) {}
        $$('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        $$('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', !c.item_count); el.hidden = false; });
      }).catch(function () {});
    }
    function ligarForm(form) {
      var btns = $$('[data-sw-atc]', form);
      function busy(btn, b) {
        btns.forEach(function (x) { x.disabled = b; });
        if (!btn) return;
        /* 2026-09-28: o rotulo NAO muda enquanto adiciona. Antes trocava para
           "Adding" com um anel a girar; o operador quer o mesmo texto do principio ao
           fim. Fica so o `aria-busy`, que nao e visivel mas diz a um leitor de ecra
           que o pedido esta a correr, e o `disabled` acima, que impede o duplo clique. */
        if (b) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
      }
      function add(btn) {
        var sel = form.querySelector('[name=id]');
        if (!sel || !sel.value) { form.submit(); return; }
        busy(btn, true);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add to cart');
            return refreshDrawer().then(function () { busy(btn, false); refreshCount(); }).catch(function () { location.href = '/cart'; });
          })
          .catch(function (err) { busy(btn, false); alert(err.message || 'Sorry, something went wrong. Please try again.'); });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = (e.submitter && e.submitter.hasAttribute('data-sw-atc')) ? e.submitter : form.querySelector('[data-sw-atc]');
        add(btn);
      });
    }
    $$('form[data-sw-buyform]').forEach(ligarForm);

    /* ---------- preço dentro do botão ----------
       NÃO somos nós a escrever os números. O Kaching está ligado nesta página e reescreve
       os dois elementos sozinho, calculando pela QUANTIDADE do bundle escolhido: com o
       bundle de dois ele mostra 2 x 149,90 riscado e o preço do bundle ao lado.

       Eu tinha aqui um cálculo pela variante e os dois ficavam a disputar o mesmo
       elemento, com quem escrevesse por último a ganhar. Isso dá um preço no botão e
       outro no carrinho, que é o pior erro possível num botão de compra.

       A fonte de verdade é o app, porque é ele que decide o que vai para o carrinho.
       O Liquid deixa os dois números preenchidos com a variante selecionada, para o
       botão nunca aparecer vazio se o app demorar ou falhar, e a partir daí é dele.

       2026-10-03 (operador): com o e-book como brinde, o app soma os $39 dele ao riscado do
       botão (Duo $338.80 = $299.80 + $39). Fica assim de propósito: o operador quer o valor
       cheio com o e-book incluído (houve uma correção que copiava o riscado da barra; foi
       desfeita no mesmo dia). */

    /* ---------- seletor de packs: o rádio manda no `select` do formulário ---------- */
    $$('[data-sw-packs]').forEach(function (packs) {
      var form = packs.closest('form') || document.getElementById('sw-form');
      var sel = form && form.querySelector('.sw-buy__idselect');
      if (!sel) return;
      function aplicar(id) {
        sel.value = id;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      $$('[data-sw-pack]', packs).forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) aplicar(r.value); });
      });
      var marcado = packs.querySelector('[data-sw-pack]:checked');
      if (marcado) aplicar(marcado.value);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
